export default "__VITE_ASSET__FMJylzYy__"